const FILLER_WORDS = [
  'um', 'uh', 'like', 'basically', 'literally', 'actually',
  'you know', 'i mean', 'kind of', 'sort of', 'right so',
];

const WEAK_PHRASES = [
  "i think maybe", "i'm not sure", "i'm not really", "i guess",
  "i suppose", "hopefully", "not sure if", "i don't know",
];

export function computeDelivery(transcript, durationSeconds, longestPauseSec) {
  if (!transcript?.trim() || durationSeconds <= 0) return null;

  const words = transcript.trim().split(/\s+/).filter(Boolean);
  const wordCount = words.length;
  const wpm = Math.round((wordCount / durationSeconds) * 60);

  let fillerCount = 0;
  const fillerWords = [];
  FILLER_WORDS.forEach((f) => {
    const regex = new RegExp(`\\b${f.replace(/\s+/g, '\\s+')}\\b`, 'gi');
    const matches = transcript.match(regex) || [];
    if (matches.length) {
      fillerCount += matches.length;
      fillerWords.push({ word: f, count: matches.length });
    }
  });

  const lower = transcript.toLowerCase();
  let weakCount = 0;
  const weakPhrases = [];
  WEAK_PHRASES.forEach((p) => {
    if (lower.includes(p)) { weakCount++; weakPhrases.push(p); }
  });

  return {
    wpm,
    filler_count: fillerCount,
    filler_words: fillerWords,
    longest_pause_sec: Math.round(longestPauseSec * 10) / 10,
    answer_duration_sec: Math.round(durationSeconds),
    weak_language_count: weakCount,
    weak_phrases: weakPhrases,
    word_count: wordCount,
  };
}

export function getMetricColor(metric, value) {
  const rules = {
    wpm: (v) => (v >= 120 && v <= 170 ? 'green' : v >= 90 && v <= 200 ? 'amber' : 'red'),
    filler_count: (v) => (v <= 2 ? 'green' : v <= 5 ? 'amber' : 'red'),
    longest_pause_sec: (v) => (v < 3 ? 'green' : v < 6 ? 'amber' : 'red'),
    answer_duration_sec: (v) => (v >= 60 && v <= 180 ? 'green' : v >= 30 && v <= 240 ? 'amber' : 'red'),
    weak_language_count: (v) => (v === 0 ? 'green' : v <= 2 ? 'amber' : 'red'),
  };
  return rules[metric]?.(value) ?? 'amber';
}

export function computeDeliveryScore(metrics) {
  if (!metrics) return null;
  let score = 100;
  score -= Math.min(metrics.filler_count * 4, 30);
  score -= Math.min(metrics.weak_language_count * 6, 20);
  const { wpm, longest_pause_sec, answer_duration_sec } = metrics;
  if (wpm < 90 || wpm > 200) score -= 15;
  else if (wpm < 120 || wpm > 170) score -= 8;
  if (longest_pause_sec > 8) score -= 15;
  else if (longest_pause_sec > 5) score -= 8;
  else if (longest_pause_sec > 3) score -= 3;
  if (answer_duration_sec < 30) score -= 20;
  else if (answer_duration_sec < 45) score -= 10;
  return Math.max(0, Math.round(score));
}

export const COLOR_CLASSES = {
  green: { bg: 'bg-[#10B981]/10', text: 'text-[#10B981]', border: 'border-[#10B981]/30' },
  amber: { bg: 'bg-[#F59E0B]/10', text: 'text-[#F59E0B]', border: 'border-[#F59E0B]/30' },
  red:   { bg: 'bg-[#E11D48]/10', text: 'text-[#E11D48]', border: 'border-[#E11D48]/30' },
};

export const LIGHT_COLOR_CLASSES = {
  green: { bg: 'bg-[#10B981]/5', text: 'text-[#10B981]', border: 'border-[#10B981]/30' },
  amber: { bg: 'bg-[#F59E0B]/5', text: 'text-[#F59E0B]', border: 'border-[#F59E0B]/30' },
  red:   { bg: 'bg-[#E11D48]/5', text: 'text-[#E11D48]', border: 'border-[#E11D48]/30' },
};
